import classNames from 'classnames'

function DotIndicators({
  size,
  activeIndex,
  classNameIndicatorDots,
  classNameActiveDot,
  classNameIndicators,
  variant,
  OnClickDot,
}) {
  let indicators = []
  for (let id = 0; id < size; id++) {
    indicators.push(
      <div
        key={id}
        className={classNames(
          'h-1.5 w-1.5 bg-white opacity-20 mx-2 my-0 p-0 rounded-[50%] border-[none] outline-none lg:w-1.5 lg:h-1.5 group-data-[variant="onWhite"]:bg-neutral-150 group-data-[variant="onWhite"]:!opacity-100',

          {
            [classNameIndicatorDots]: Boolean(classNameIndicatorDots),
            // Active state
            '!opacity-100 !bg-[#30f]': activeIndex === id, // on-indicator
            'group-data-[variant="onWhite"]:bg-[#3b6af7] group-data-[variant="onWhite"]:opacity-100':
              activeIndex === id,
            [classNameActiveDot]: Boolean(classNameActiveDot) && activeIndex === id,
          }
        )}
        data-testid={`dot-indicator-dot-${id}`}
        onClick={() => typeof OnClickDot === 'function' && OnClickDot(id)}
      />
    )
  }

  return (
    <div
      data-variant={variant}
      className={classNames(
        classNameIndicators,
        'flex justify-center items-center w-full z-[1] relative',
        'group'
      )}
      role="group"
      data-testid="dot-indicator-container"
    >
      {indicators}
    </div>
  )
}

export { DotIndicators }
